"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _commonCta = require("@mmc/common-cta");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _shoppingToolsCard = _interopRequireDefault(require("./shopping-tools-card.css"));
var ShoppingToolsCard = function ShoppingToolsCard(_ref) {
  var className = _ref.className,
    theme = _ref.theme,
    data = _ref.data;
  var ctas = data.ctas,
    label = data.label;
  var eventHandler = function eventHandler(link, labelComp) {
    var _window, _window$dataLayer;
    var modelName = '';
    if (window.location && window.location.pathname) {
      var pathnames = window.location.pathname.split('/');
      var pathnamePosition = pathnames.length >= 3 ? 2 : 1;
      // eslint-disable-next-line prefer-destructuring
      modelName = pathnames[pathnamePosition];
    }
    (_window = window) == null ? void 0 : (_window$dataLayer = _window.dataLayer) == null ? void 0 : _window$dataLayer.push({
      event: 'linkclickevent',
      section_name: labelComp,
      component: 'Shopping Tools Cards',
      action: 'CTA click',
      click_text: link.label,
      nameplate: modelName
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(_shoppingToolsCard["default"].shoppingToolsSmallCardsContainer, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _shoppingToolsCard["default"].shoppingToolsSmallCardsTitle
  }, /*#__PURE__*/_react["default"].createElement("h2", null, label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _shoppingToolsCard["default"].shoppingToolsSmallCards
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: _shoppingToolsCard["default"].links
  }, ctas.map(function (link, index) {
    var _clsx;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: _shoppingToolsCard["default"].shoppingToolsSmallCardsItems
    }, /*#__PURE__*/_react["default"].createElement("li", {
      style: {
        width: 100 / link.length + "%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: link,
      theme: theme,
      "data-section": "shopping tool small cards",
      spanClasses: (0, _clsx2["default"])(theme.black),
      clickEvent: function clickEvent() {
        return eventHandler(link, label);
      },
      classes: (0, _clsx2["default"])(theme.labelMedium, theme.black, (_clsx = {}, _clsx[_shoppingToolsCard["default"].iconStyle] = !link.customImage, _clsx))
    })));
  }))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
ShoppingToolsCard.resourceType = function () {
  return 'ShoppingToolsCards_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(ShoppingToolsCard);
exports["default"] = _default;